import React from "react";
import "./InplaceProgress.scss";

const InplaceProgress = () => {
	return (
		<div className="flex direction-col justify-content-center align-items-center" style={{ width: "100%" }}>
			<div className="loader"></div>
		</div>
	);
};

export default InplaceProgress;
